import { tokens } from "@fluentui/react-components";


export const analyticsDashboardStyles = (smallScreen?: boolean) => ({
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    "&:hover": {
      backgroundColor: tokens.colorNeutralBackground1
    },
    width: "100%",
    MaxWidth: "1260px"
  },
  chartGroup: {
    gap: "8px"
  },
  chartColors: {
    primary: tokens.colorBrandBackground2,
    success: tokens.colorBrandBackground2,
    warning: tokens.colorBrandBackground3Static,
    error: tokens.colorPaletteRedBackground2,
    border: tokens.colorNeutralBackground1,
    transparent: "transparent",
    labelColor: tokens.colorNeutralForeground1,
    lineColor1: tokens.colorBrandForeground2,
    lineColor2: tokens.colorPaletteBlueBackground2,
    lineColor3: tokens.colorBrandBackgroundPressed,
    lineColor4: tokens.colorBrandBackground4Static,
    lineColor5: tokens.colorBrandForeground2,
    lineColor6: tokens.colorBrandBackgroundSelected,
    lineColor7: tokens.colorBrandForeground1
  },
  chartCards: {
    backgroundColor: tokens.colorNeutralBackground1,
    "&:hover": {
      backgroundColor: tokens.colorNeutralBackground1
    },
    padding: "10px",
    width: smallScreen ? "340px" : "546px",
    height: smallScreen ? "207px" : "308px"
  },
  metricButton: {
    justifyContent: "flex-start",
    margin: "0 0 0 19px"
  },
  metricGroupButton: {
    justifyContent: "flex-start",
    padding: "0"
  },
  valueButton: {
    justifyContent: "flex-end"
  },
  cell: {
    display: "flex",
    justifyContent: "flex-end"
  },
  description: {
    color: tokens.colorNeutralForeground2
  },
  momPositive: {
    color: tokens.colorPaletteGreenForeground2
  },
  momNegative: {
    color: tokens.colorPaletteRedForeground1
  },
  text: {
    color: tokens.colorNeutralForeground2,
    width: "248px"
  },
  tabText: {
    fontSize: "small",
    margin: "0 15px 0 0",
    padding: "0 0 4px 0",
    borderWidth: "0 0 2px 0",
    borderSyle: "none",
    minWidth: "0px",
    borderColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground2
  },
  selectedTabText: {
    fontSize: "small",
    fontWeight: "bold",
    margin: "0 15px 0px 0",
    padding: "0 0 4px 0",
    borderWidth: "0 0 2px 0",
    borderSyle: "solid",
    borderColor: tokens.colorBrandForeground2Pressed,
    minWidth: "0px",
    color: tokens.colorNeutralForeground1Selected
  }
});
